import { forwardRef } from 'react';

import { IconProps } from '../';

export const TimelineTriangleDownIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <g clipPath="url(#clip0_4003_40711)">
        <g filter="url(#filter0_d_4003_40711)">
          <path
            d="M10.8515 14.6174C10.4609 15.2515 9.53906 15.2515 9.14851 14.6174L4.01057 6.27438C3.60026 5.60812 4.07959 4.75 4.86206 4.75L15.1379 4.75C15.9204 4.75 16.3997 5.60812 15.9894 6.27438L10.8515 14.6174Z"
            fill="#B0B2B4"
          />
          <path
            d="M11.7031 15.1416C10.922 16.4099 9.07796 16.4099 8.29688 15.1416L3.15918 6.79883C2.33856 5.46631 3.29737 3.75 4.86231 3.75L15.1377 3.75C16.7026 3.75 17.6614 5.46631 16.8408 6.79883L11.7031 15.1416Z"
            fill="none"
            stroke="white"
            strokeWidth="2"
          />
        </g>
      </g>
      <defs>
        <filter id="filter0_d_4003_40711" x="-0.142685" y="1.75" width="20.2854" height="18.3428" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4003_40711" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4003_40711" result="shape" />
        </filter>
        <clipPath id="clip0_4003_40711">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

export default TimelineTriangleDownIcon;
